"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaintField = void 0;
const react_1 = __importDefault(require("react"));
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../Colors");
const constants_1 = require("../../constants");
const index_1 = require("./FieldName/index");
const index_2 = require("../Type/index");
const Main = typestyle_1.style({
    display: 'flex',
    alignItems: 'center',
    color: Colors_1.Colors.grey[0],
    height: constants_1.FIELD_HEIGHT,
    margin: `0 0`,
    transition: 'background 0.25s ease-in-out',
    $nest: {
        '.NodeFieldPortPlaceholder': {
            width: 24,
            height: 16,
        },
    },
});
const LastField = typestyle_1.style({
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
});
const Title = typestyle_1.style({
    fontSize: 10,
    display: 'flex',
    flex: 1,
    alignItems: 'baseline',
    overflow: 'hidden',
});
const Name = typestyle_1.style({ fontSize: 12, marginRight: 4, overflow: 'hidden' });
const Type = typestyle_1.style({ fontSize: 10, color: Colors_1.Colors.green[0] });
exports.PaintField = ({ node, last, parentNodeTypeName }) => {
    return (react_1.default.createElement("div", { className: `NodeType-${parentNodeTypeName} ${Main} ${last ? LastField : ''}` },
        react_1.default.createElement("div", { className: 'NodeFieldPortPlaceholder' }),
        react_1.default.createElement("div", { className: Title },
            react_1.default.createElement("div", { className: Name },
                react_1.default.createElement(index_1.PaintFieldName, { data: node.data, name: node.name, args: node.args })),
            react_1.default.createElement("div", { className: Type },
                react_1.default.createElement(index_2.PaintType, { type: node.type }))),
        react_1.default.createElement("div", { className: 'NodeFieldPortPlaceholder' })));
};
